/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Case_Documents_Requested_OnInputs */

const en_case_documents_requested_on = /** @type {(inputs: Case_Documents_Requested_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Requested on ${i?.date}`)
};

const pt_br2_case_documents_requested_on = /** @type {(inputs: Case_Documents_Requested_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Solicitado em ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Requested on {date}" |
*
* @param {Case_Documents_Requested_OnInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_documents_requested_on = /** @type {((inputs: Case_Documents_Requested_OnInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Documents_Requested_OnInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_documents_requested_on(inputs)
	return pt_br2_case_documents_requested_on(inputs)
});